export default __webpack_public_path__ + "static/media/6-min.ff7130b6.jpg";